webpackJsonp([257507169568505],{

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var page_1 = __webpack_require__(42);
	var GhostTyper_1 = __webpack_require__(59);
	var IndexPage = function IndexPage() {
	    return React.createElement(page_1.default, null, React.createElement("h1", null, "Contact"), React.createElement("p", null, React.createElement(GhostTyper_1.default, { text: "Interested in contacting me or to know more of me and what i do?" })), React.createElement("p", null, "Github: ", React.createElement("a", { target: "_blank", href: "https://www.github.com/philipedin" }, "github.com/philipedin")), React.createElement("p", null, "LinkedIn: ", React.createElement("a", { target: "_blank", href: "https://www.linkedin.com/in/philip-edin-b4ab13133" }, "linkedin.com/in/philip-edin-b4ab13133")), React.createElement("p", null, "Email: ", React.createElement("a", { target: "_blank", href: "mailto:philip.edin.alt@gmail.com" }, "philip.edin.alt@gmail.com")));
	};
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-tsx-3c0cc5075b550359d9b7.js